import React from "react";
import { join, pipe, splitAt } from "ramda";

const formatNhsNumber = pipe(splitAt(3), join(" "), splitAt(7), join(" "));
export const NhsNumber: React.FC<{ value: string }> = ({ value }) => <> {formatNhsNumber(value)} </>;
